import { ErrorMessage, Field, FormikValues } from "formik";
import React from "react";
import { CURRENCY } from "../../../../components/Constants";

interface BasicFieldsProps {
  values: FormikValues;
  handleChange: (e: React.ChangeEvent<any>) => void;
}

const TotalFields: React.FC<BasicFieldsProps> = ({ values, handleChange }) => {
  return (
    <>
      <div className="col-12 col-sm-6 col-lg-3 mt-4">
        <label
          htmlFor="sub_total"
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Total Amount ({CURRENCY.USD.SYMBOL}):{" "}
          <span className="text-danger">*</span>
        </label>
        <Field
          name="sub_total"
          type="number"
          className="form-control"
          value={values.sub_total}
          onChange={handleChange}
        />
        <ErrorMessage
          name="sub_total"
          component="div"
          className="text-danger"
        />
      </div>

      <div className="col-12 col-sm-6 col-lg-3 mt-4">
        <label
          htmlFor="total_no_of_bags"
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Total No. of Bags:
        </label>
        <Field
          name="total_no_of_bags"
          type="number"
          className="form-control"
          value={values.total_no_of_bags || ""}
          onChange={handleChange}
        />
        <ErrorMessage
          name="total_no_of_bags"
          component="div"
          className="text-danger"
        />
      </div>

      <div className="col-12 col-sm-6 col-lg-3 mt-4">
        <label
          htmlFor="total_net_weight"
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Total Net Weight (KGS):
        </label>
        <Field
          name="total_net_weight"
          type="number"
          className="form-control"
          value={values.total_net_weight || ""}
          onChange={handleChange}
        />
        <ErrorMessage
          name="total_net_weight"
          component="div"
          className="text-danger"
        />
      </div>

      <div className="col-12 col-sm-6 col-lg-3 mt-4">
        <label
          htmlFor="total_gross_weight"
          className="form-label"
          style={{ fontSize: "0.9375rem" }}
        >
          Total Gross Weight (KGS):
        </label>
        <Field
          name="total_gross_weight"
          type="number"
          className="form-control"
          value={values.total_gross_weight || ""}
          onChange={handleChange}
        />
        <ErrorMessage
          name="total_gross_weight"
          component="div"
          className="text-danger"
        />
      </div>
    </>
  );
};

export default TotalFields;
